export const AI_INSPIRATION_ID_PREFIX = 'ai-insp-';

/** 为图库条目加上 AI 灵感 id 前缀，避免与素材推荐/图片空间 id 冲突 */
export function mapGalleryItemsWithAiInspirationIds(selectedItems) {
  return (selectedItems || []).map((item) => {
    const rawId = item?.id != null ? String(item.id) : '';
    if (!rawId) return item;
    if (rawId.startsWith(AI_INSPIRATION_ID_PREFIX)) return item;
    return { ...item, id: `${AI_INSPIRATION_ID_PREFIX}${rawId}` };
  });
}
